









import BaseIconAlert from "@/components/Base/BaseIconAlert.vue";

export default {
  name: "NoLocationSelected",
  components: { BaseIconAlert }
};
